function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 1.4165C20.1734 1.4165 25.5833 6.82641 25.5833 13.4998C25.5833 20.1733 20.1734 25.5832 13.5 25.5832C6.82657 25.5832 1.41666 20.1733 1.41666 13.4998C1.41666 6.82641 6.82657 1.4165 13.5 1.4165Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1855 14.0638C16.3047 15.0135 13.9073 16.6206 12.6809 17.1366C12.4851 17.2187 11.9861 17.3927 11.8785 17.3952C11.6502 17.4024 11.4302 17.2743 11.3239 17.0689C11.2828 16.9892 11.162 16.4684 11.1233 16.2364C11.0085 15.5307 10.9493 14.4347 10.9505 13.3327C10.9493 12.1764 11.0134 11.0284 11.1415 10.33C11.1753 10.1415 11.2744 9.70774 11.3034 9.63766C11.3577 9.50716 11.4568 9.40445 11.5765 9.34041C11.6683 9.29086 11.7734 9.26428 11.8785 9.26791C11.9861 9.27032 12.4235 9.42378 12.5733 9.48299C13.7551 9.94216 16.2551 11.6072 17.1735 12.586C17.2556 12.6742 17.4816 12.911 17.519 12.9594C17.6048 13.0681 17.6471 13.1998 17.6471 13.3327C17.6471 13.456 17.6097 13.5817 17.5323 13.6868C17.4925 13.7412 17.2617 13.9828 17.1855 14.0638Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.7ca0b486.svg";
export { ForwardRef as ReactComponent };